import C, { lower } from 'constants';
import viKeyboardTab from '../icons/viKeyboardTab';
import viLock from '../icons/viLock';
import viInfinity from '../icons/viInfinity';

/**
 * List of supported Order Types
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 * @param options.emptyData object of data to spread into the empty name/value pair if includeEmpty is true
 */
export function list(options = {}) {
  const list = [
    {
      label: 'Direct',
      value: 'direct',
      description: `These house multiple ${lower(C.SEGMENTS)} that will provide
      a roll up of information for directly serving out of the ISM system.`,
      icon: viKeyboardTab,
    },
    {
      label: 'Direct (External)',
      value: 'direct-ext',
      description: '',
      icon: viKeyboardTab,
    },
    {
      label: 'Programmatic Guaranteed Deal',
      value: 'programmatic',
      description: 'A programmatic deal served from a DSP that has guaranteed inventory.',
      icon: viLock,
    },
    {
      label: 'Always-On (PMP)',
      value: 'always-on-pmp',
      description: `A programmatic deal served from a DSP that has non-guaranteed inventory;
      generating a deal id for invitation-only programmatic auction, or evergreen deal,
      without a specific spend commitment.`,
      icon: viInfinity,
    },
  ];

  if (options.includeEmpty === true) {
    const emptyData = options.emptyData ?? {};

    list.unshift({
      label: '',
      value: '',
      ...emptyData,
    });
  }

  return list;
}

export default {
  list,
};
